/* eslint-disable no-prototype-builtins */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form} from 'react-redux-form';
import { Checkbox, Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import { get } from 'lodash';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import { createCarousel, getCarousel, getCarousels, updateCarousel } from '../../../../actions/home';
import ImageUpload from '../../../common/form/elements/image-upload';
import { API_REP_HOME_PAGE, UI_REP_HOME_PAGE, UI_RETAILER_HOME_PAGE, PRELOGIN_HOME_PAGE } from '../../../../data/homePageTypes';
import MultiSelect from '../../../common/form/multi-select';
import { history } from '../../../../store';
import Select from '../../../common/form/elements/select';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import DatePicker from '../../../common/form/datepicker';


const generatePermissionsForEdit = (carousel, id) => {
  const { permissions } = carousel;

  if (permissions.length) {
    return (permissions.map((permission, index) => (
      <FormGroup className="permission-block" key={`perm-group-${index}`}>
        {['Stores', 'Usergroups'].includes(permission.name) && (
          <b>
            {permission.name}
          </b>
        )}
        {
          permission.children.filter(child => ['Reward Store', 'Non Reward Store', 'Owner', 'Staff'].includes(child.name))
            .map((child, i) => {
              if (child.checked) {
                return (
                  <Control.checkbox
                    key={`perm-${i}`}
                    defaultChecked
                    disabled={id === 1}
                    model={`deep.home_page_carousel.permission_ids[${child.id}].checked`}
                    component={Checkbox}
                  >
                    {child.name}
                  </Control.checkbox>
                );
              }
              return (
                <Control.checkbox
                  key={`perm-${i}`}
                  component={Checkbox}
                  disabled={id === 1}
                  model={`deep.home_page_carousel.permission_ids[${child.id}].checked`}
                >
                  {child.name}
                </Control.checkbox>
              );
            })
        }
      </FormGroup>
    )));
  }

  return null;
};

const generatePermissions = (permissions) => {
  if (permissions.length) {
    return (permissions.map((permission, index) => (
      <FormGroup className="permission-block" key={`perm-group-${index}`}>
        {['Stores', 'Usergroups'].includes(permission.name) && (
          <b>
            {permission.name}
          </b>
        )}
        {
          permission.children.filter((child => ['Reward Store', 'Non Reward Store', 'Owner', 'Staff'].includes(child.name)))
            .map((child, i) => (
              <Control.checkbox
                key={`perm-${i}`}
                defaultChecked
                model={`deep.home_page_carousel.permission_ids[${child.id}].checked`}
                component={Checkbox}
              >
                {child.name}
              </Control.checkbox>
            ))
        }
      </FormGroup>
    )));
  }

  return null;
};

class NewCarousel extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.match.params.id;
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getCarousels());

    if (this.isEdit() || this.isClone()) {
      dispatch(getCarousel(this.id));
    } else {
      dispatch(getCarousel('new'));
      dispatch(actions.reset('deep.home_page_carousel'));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.home_page_carousel'));
  }

  onImageLoaded = (data) => {
    this.setState({
      ...this.state,
      image: data
    });
  };

  onMobileImageLoaded = (data) => {
    this.setState({
      ...this.state,
      mobile_image: data
    });
  };

  getHomePageType = () => {
    const { carousel, match } = this.props;

    if (this.isEdit()) {
      const homePageType = get(carousel, 'home_page_type');

      if (homePageType === API_REP_HOME_PAGE) {
        return UI_REP_HOME_PAGE;
      } else if (homePageType === PRELOGIN_HOME_PAGE) {
        return PRELOGIN_HOME_PAGE;
      }

      return UI_RETAILER_HOME_PAGE;
    }

    return match.params.type;
  };

  onSubmit = (payLoad) => {
    const { dispatch } = this.props;
    const homePageType = this.getHomePageType();

    if (this.isEdit() && !this.isClone()) {
      dispatch(actions.submitFields('deep.home_page_carousel', updateCarousel(this.id, payLoad, homePageType)));
    } else {
      dispatch(actions.submitFields('deep.home_page_carousel', createCarousel(payLoad, homePageType)));
    }
  };

  isEdit() {
    return this.id && parseInt(this.id);
  }

  isClone = () => {
    const { match: { url } } = this.props;

    return url.includes('clone');
  }

  createGroupList = (groups) => {
    const grps = groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

    return grps;
  };

  handleAddNewVersionClick = () => {
    history.push(`/admin/homepage/carousel/${this.id}/clone`);
  };

  pageTitle = () => {
    if (this.isClone()) {
      return 'Add new slide version';
    } else if (this.isEdit()) {
      return 'Edit Slide';
    }

    return 'Add Slide';
  }

  createArticlesList = articles => ({
    0: 'Other',
    ...articles
  });

  render() {
    const {
      carousel, permissions, textColor, buttonColor, textAlignment, carouselLoading
    } = this.props;
    const homePageType = this.getHomePageType();
    let image = '';
    let mobileImage = '';

    if (this.props.formData.hasOwnProperty('link') && this.props.formData.link.hasOwnProperty('image')) {
      ({ image } = this.props.formData.link);
    }

    if (this.props.formData.hasOwnProperty('link') && this.props.formData.link.hasOwnProperty('mobile-image')) {
      ({ 'mobile-image': mobileImage } = this.props.formData.link);
    }

    const buttonLinkDisabled = !!this.props.formData.button_article_link && this.props.formData.button_article_link !== '0';

    if (carouselLoading) {
      return (
        <div className="container-fluid">
          <PageTitle>
            {this.pageTitle()}
          </PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href={`/admin/homepages/${homePageType}#carousel`}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              {this.pageTitle()}
            </PageTitle>
          </Col>
        </Row>
        {this.isEdit() && !this.isClone() && (
          <Row>
            <Col lg={12}>
              <p>
                  Carousel ID: {this.id}
              </p>
            </Col>
          </Row>
        )}
        <Form model='deep.home_page_carousel' onSubmit={this.onSubmit.bind(this)}>
          <Row>
            <Col md={12}>
              <Errors className="errors" model="deep.home_page_carousel"/>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ControlLabel>
                Image*
              </ControlLabel>
              <ImageUpload
                onImageLoaded={this.onImageLoaded}
                sizeLimit={2 * 1024 * 1024}
                source={image}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ControlLabel>
                Mobile Image
              </ControlLabel>
              <ImageUpload
                model="deep.home_page_carousel.mobile_image"
                onImageLoaded={this.onMobileImageLoaded}
                sizeLimit={2 * 1024 * 1024}
                source={mobileImage}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
          <Col md={12}>
            <Control model="deep.home_page_carousel.text_color" type="hidden" value={textColor}/>
            <FormGroup controlId="title">
              <ControlLabel>
                Title
              </ControlLabel>
              <Errors
                className="errors"
                model="deep.home_page_carousel.title"
                show={{touched: true}}
              />
              <Control.text
                component={FormControl}
                model="deep.home_page_carousel.title"
              />
            </FormGroup>
            <FormGroup controlId="text">
              <ControlLabel>
                Text
              </ControlLabel>
              <Errors
                className="errors"
                model="deep.home_page_carousel.text"
                show={{touched: true}}
              />
              <Control.text
                component={FormControl}
                model="deep.home_page_carousel.text"
              />
            </FormGroup>
            <Control model="deep.home_page_carousel.button_color" type="hidden" value={buttonColor}/>
            <RequiredDatePicker
              controlId="display_from_date"
              label="Display from date"
              model="deep.home_page_carousel.display_from_date"
              placeholder="Select a date..."
              value={this.props.formData.display_from_date}
              timeFormat="HH:mm"
            />
            <DatePicker
              label="Display to date"
              model="deep.home_page_carousel.display_to_date"
              placeholder="Select a date..."
              timeFormat="HH:mm"
              value={this.props.formData.display_to_date}
            />
            <FormGroup controlId="button_label">
              <ControlLabel>
                Button label
              </ControlLabel>
              <Errors
                className="errors"
                model="deep.home_page_carousel.button_label"
                show={{touched: true}}
              />
              <Control.text
                component={FormControl}
                model="deep.home_page_carousel.button_label"
              />
            </FormGroup>
            <FormGroup controlId="button_link">
              <ControlLabel>
                Button link
              </ControlLabel>
              <Errors
                className="errors"
                model="deep.home_page_carousel.button_link"
                show={{touched: true}}
              />
              <Select
                controlId="button_article_link"
                label="Article"
                model="deep.home_page_carousel.button_article_link"
                labelAttr='attributes.name'
                valueAttr='id'
                values={this.createArticlesList(this.props.articles)}
                selectedValue={this.props.formData.button_article_link}
              />
              <Control.text
                component={FormControl}
                model="deep.home_page_carousel.button_link"
                disabled={buttonLinkDisabled}
                value={buttonLinkDisabled ? '' : this.props.formData.button_link}
              />
            </FormGroup>
            <Control model=".text_alignment" type="hidden" value={textAlignment}/>
            { homePageType !== 'pre_login' ? (
              <div>
                <h3>
                    Slide Permissions
                </h3>
                <Row>
                  <Col md={12}>
                    <MultiSelect
                      model='deep.home_page_carousel.group_ids'
                      data={this.createGroupList(this.props.groups) || []}
                      label="Outlet Groups"
                      value={this.props.formData.group_ids}
                      controlId="groups"
                      withAllOption
                    />
                  </Col>
                </Row>
                {(!this.isEdit() && permissions) &&
                    generatePermissions(permissions)
                  }
                {(this.isEdit() && carousel) &&
                    generatePermissionsForEdit(carousel, this.id)
                  }
              </div>
              ) :
              null
            }
          </Col>
          <Row>
            {
              this.isEdit() && (
                <Col md={2} mdOffset={9}>
                  <ArrowButton
                    arrow={false}
                    className="pull-right"
                    submit={false}
                    onClick={this.handleAddNewVersionClick}
                    disabled={this.isClone()}
                  >
                    Add new version
                  </ArrowButton>
                </Col>
              )
            }
            <Col md={this.isEdit() ? 1 : 2} mdOffset={this.isEdit() ? 0 : 10}>
              <ArrowButton
                arrow={false}
                className="pull-right"
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  permissions: state.home.permissions,
  carousel: state.home.carousel,
  formData: state.deep.home_page_carousel,
  groups: state.home.groups || [],
  articles: state.home.articles || [],
  carouselLoading: state.home.fetching && !state.home.fetched,
  textColor: state.deep.forms.home_page_carousel.text_color.value,
  buttonColor: state.deep.forms.home_page_carousel.button_color.value,
  textAlignment: state.deep.forms.home_page_carousel.text_alignment.value
});

export default connect(mapStateToProps)(NewCarousel);



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/add-carousel/index.jsx